import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",

    primary: {
      main: "#D6AF6E"
    },

    text: {
      primary: "#2E2E2E",
      secondary: "#6A717D"
    },

    background: {
      default: "#F7F8FA",
      paper: "#FFFFFF"
    },

    divider: "#ECECEC",

    action: {
      hover: "#F5F5F5",
      selected: "#EFE7DA"
    }
  },

  shape: {
    borderRadius: 18
  },

  typography: {
    fontFamily: `"Inter", "Roboto", "Helvetica", "Arial", sans-serif`,

    h1: { fontWeight: 900 },
    h2: { fontWeight: 900 },
    h3: { fontWeight: 900 },
    h4: { fontWeight: 900 },
    h5: { fontWeight: 900 },
    h6: { fontWeight: 900 },

    subtitle1: {
      fontSize: 14,
      fontWeight: 800
    },

    body1: {
      fontSize: 14,
      lineHeight: 1.6
    },

    body2: {
      fontSize: 13,
      lineHeight: 1.6
    },

    caption: {
      fontSize: 12
    },

    button: {
      textTransform: "none",
      fontWeight: 800
    }
  },

  components: {
MuiCssBaseline: {
  styleOverrides: {
    body: {
      backgroundColor: "#F7F8FA"
    },

    ".rounded-image": {
      borderRadius: 12,
      overflow: "hidden"
    },

    ".sectionHeader": {
      display: "flex",
      alignItems: "center",
      gap: "16px",
      marginBottom: "12px"
    },

    ".sectionHeaderTitle": {
      fontSize: "13.5px",
      color: "#2E2E2E",
      fontWeight: 800
    },

    ".sectionHeaderLine": {
      height: "2px",
      width: "34px",
      backgroundColor: "#D6AF6E",
      borderRadius: "999px",
      opacity: 0.9
    },

    // ✅ NEW: Disable hover for parent menu items that have submenu
    ".noParentHover:hover": {
      backgroundColor: "transparent !important"
    },
    ".noParentHover.Mui-selected:hover": {
      backgroundColor: "#EFE7DA !important"
    }
  }
},


    MuiCard: {
      defaultProps: {
        elevation: 0
      },
      styleOverrides: {
        root: {
          borderRadius: 18,
          border: "1px solid #ECECEC",
          backgroundImage: "none"
        }
      }
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 18
        }
      }
    },

    MuiCardContent: {
      styleOverrides: {
        root: {
          paddingTop: 18,
          paddingBottom: 18,
          paddingLeft: 20,
          paddingRight: 20
        }
      }
    },

    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          borderRadius: 14,
          fontWeight: 800
        }
      }
    },

    MuiChip: {
      styleOverrides: {
        root: {
          height: 22,
          fontSize: 11,
          borderRadius: 999,
          backgroundColor: "#F5F5F5",
          color: "#6A717D",
          fontWeight: 800
        }
      }
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          borderRadius: 12
        }
      }
    },

    MuiTextField: {
      defaultProps: {
        size: "small"
      }
    },

    MuiSelect: {
      defaultProps: {
        size: "small"
      }
    },

    // ✅ Sidebar/menu buttons — consistent everywhere
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 15,
          paddingTop: 14,
          paddingBottom: 14,
          transition: "all 0.25s ease",

          "&:hover": {
            backgroundColor: "#F5F5F5"
          },

          "&.Mui-selected": {
            backgroundColor: "#EFE7DA",
            color: "#D6AF6E",

            "& .MuiListItemIcon-root": {
              color: "#D6AF6E"
            }
          },

          // ✅ IMPORTANT FIX:
          // Selected item should NOT change hover background
          "&.Mui-selected:hover": {
            backgroundColor: "#EFE7DA"
          }
        }
      }
    },

    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 42,
          color: "#6A717D"
        }
      }
    }
  },

  custom: {
    sidebarWidth: 260,
    pageGap: 24,
    cardRadius: 18,
    imageRadius: 12
  }
});

export default theme;
